import type { ReactNode } from "react";

type SectionProps = { children: ReactNode };

export function LpInputsSection({ children }: SectionProps) {
  return <>{children}</>;
}

export function LpDashboardSection({ children }: SectionProps) {
  return (
    <div className="space-y-4" data-testid="card-lp-express-pages">
      {children}
    </div>
  );
}

export function LpEditorShell({ children }: SectionProps) {
  return <>{children}</>;
}

export function LpPublishSettingsSection({ children }: SectionProps) {
  return <>{children}</>;
}

export function LpRegenerationControls({ children }: SectionProps) {
  return <>{children}</>;
}